<div id="wrap">
    <header class="header">
        <div class="header_inner">
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right">
                <button type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
                <a routerLink="/join" class="btn_join"><b>회원가입</b></a>
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
        </div>
    </header>

    <div id="content">
        <div id="skip_anchor" class="content page_account autoWd">
            <div class="form_account">
                <strong class="account_title">아이디 찾기</strong>
                <div class="account_box required_group" *ngIf="!list">
                    <p class="account_subscript">개인정보 보호를 위하여 <br />본인 확인이 필요합니다.</p>
                    <p class="account_desc">회원가입 시 등록한 이름과 휴대폰 번호를 입력해 주세요.</p>
                    <fieldset>
                        <legend class="blind">아이디 찾기</legend>
                        <div class="account_form">
                            <label>이름</label>
                            <input type="text" [(ngModel)]="name" class="form_input required" placeholder="이름을 입력해 주세요."/>
                        </div>
                        <div class="account_form">
                            <label>핸드폰 번호</label>
                            <input type="text" [(ngModel)]="tel" (keyup.enter)="otpSend()" [disabled]="isOtpSend" class="form_input required" placeholder="핸드폰 번호를 입력해 주세요."/>
                            <button type="button" class="form_button btn_required" (click)="otpSend()" [disabled]="isOtpSend">인증번호</button>
                        </div>
                        <div class="account_form">
                            <label>인증번호 입력</label>
                            <input type="text" [(ngModel)]="otpCode" (keyup.enter)="otpCheck()" [disabled]="isOtpConfirmTry && isOtpSend" class="form_input required" placeholder="인증번호를 입력해 주세요." />
                            <span *ngIf="isOtpSend || isOtpConfirmTry" class="form_timer">{{displayTime}}</span>
                            <button type="button" class="form_button btn_required" (click)="otpCheck()" [disabled]="!isOtpSend || isOtpConfirm">확인</button>
                        </div>
                        <div class="btn">
                            <button class="btn_item btn_required" (click)="findId()" [disabled]="!(name && isOtpConfirm)">아이디 찾기</button>
                        </div>
                    </fieldset>
                </div>
                <div class="account_box required_group" *ngIf="isDoFindId && list && list.length > 0">
                    <p class="account_subscript">고객님의 정보와 일치하는 아이디는 <br />아래와 같습니다.</p>
                    <!-- 혹시라도 계정이 여러개인 경우 -->
                    <ng-container *ngFor="let item of list">
                        <div class="account_inner">
                            <em class="account_id">{{item.userId}}</em>
                            <span class="account_date">가입일자: {{item.regDate | date: 'yyyy년 MM월 dd일'}}</span>
                        </div>
                    </ng-container>
                    <div class="btn">
                        <button class="btn_item color-4" routerLink="/login">로그인 하기</button>
                        <ng-container *ngIf="userId && otpCode && tel">
                            <button class="btn_item btn_required" routerLink="/find/pw/{{userId}}/{{tel}}/{{otpCode}}">비밀번호 재발급</button>
                        </ng-container>
                        <ng-container *ngIf="!(userId && otpCode && tel)">
                            <button class="btn_item btn_required" routerLink="/find/pw">비밀번호 재발급</button>
                        </ng-container>
                    </div>
                </div>
                <div class="account_box required_group" *ngIf="isDoFindId && !(list && list.length > 0)">
                    <p class="account_subscript min">고객님의 정보와 <span class="emphasis">일치하는 아이디가 없습니다.</span></p>
                    <p class="account_subscript min">다시 확인 후 정보를 정확히 입력해 주세요.</p>
                    <div class="btn">
                        <button class="btn_item color-4" routerLink="/find/id">돌아가기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <footer class="footer">
        <app-footer></app-footer>
    </footer>
</div>
